var _path, _path2, _path3, _path4, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _path5, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _circle, _path6, _line, _path7, _path8, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _path9, _path10, _path11, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _path12, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatusCode404(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 323,
    viewBox: "0 0 512 323",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83.3823 56.5652H48.5179C33.3044 37.2303 53.2733 30.8141 61.5921 36.7559C84.176 14.1739 99.6272 47.4539 83.3823 56.5652Z",
    fill: "#EAF2F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M465.694 30.7981H447.083C437.742 18.5281 453.462 19.3569 457.376 22.0937C468.08 8.23128 473.338 26.6014 465.694 30.7981Z",
    fill: "#EAF2F8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M338.848 45.983L289.721 45.9844C274.507 26.6496 288.159 15.6876 318.249 26.7839C347.963 5.78492 357.868 37.4779 338.848 45.983Z",
    fill: "#EAF2F8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M369.862 68.8232C369.862 64.405 373.444 60.8232 377.862 60.8232H445.321C449.739 60.8232 453.321 64.405 453.321 68.8232V292.454H369.862V68.8232Z",
    fill: "#F1F6F9"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 386.836,
    y: 73.887,
    width: 22.633,
    height: 27.6527,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 415.127,
    y: 73.887,
    width: 22.633,
    height: 27.6527,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 386.836,
    y: 107.467,
    width: 22.633,
    height: 27.6527,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 415.127,
    y: 107.467,
    width: 22.633,
    height: 27.6527,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 386.836,
    y: 141.048,
    width: 22.633,
    height: 27.6527,
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 415.127,
    y: 141.048,
    width: 22.633,
    height: 27.6527,
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 386.836,
    y: 174.624,
    width: 22.633,
    height: 27.6527,
    fill: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 415.127,
    y: 174.624,
    width: 22.633,
    height: 27.6527,
    fill: "white"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 386.836,
    y: 208.204,
    width: 22.633,
    height: 27.6527,
    fill: "white"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 415.127,
    y: 208.204,
    width: 22.633,
    height: 27.6527,
    fill: "white"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 386.632,
    y: 242.145,
    width: 22.633,
    height: 27.6527,
    fill: "white"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 414.922,
    y: 242.145,
    width: 22.633,
    height: 27.6527,
    fill: "white"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 386.427,
    y: 276.085,
    width: 22.633,
    height: 16.3684,
    fill: "white"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 414.717,
    y: 276.085,
    width: 22.633,
    height: 16.3684,
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M420.171 105.506C420.171 101.088 423.752 97.5063 428.171 97.5063H482.413C486.831 97.5063 490.413 101.088 490.413 105.506V292.454H420.171V105.506Z",
    fill: "#DBE9F4"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 434.455,
    y: 108.503,
    width: 19.0486,
    height: 23.2733,
    fill: "white"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 458.267,
    y: 108.503,
    width: 19.0486,
    height: 23.2733,
    fill: "white"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 434.455,
    y: 136.765,
    width: 19.0486,
    height: 23.2733,
    fill: "white"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 458.267,
    y: 136.765,
    width: 19.0486,
    height: 23.2733,
    fill: "white"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 434.455,
    y: 165.027,
    width: 19.0486,
    height: 23.2733,
    fill: "white"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 458.267,
    y: 165.027,
    width: 19.0486,
    height: 23.2733,
    fill: "white"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 434.455,
    y: 193.285,
    width: 19.0486,
    height: 23.2733,
    fill: "white"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 458.267,
    y: 193.285,
    width: 19.0486,
    height: 23.2733,
    fill: "white"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 434.455,
    y: 221.547,
    width: 19.0486,
    height: 23.2733,
    fill: "white"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 458.267,
    y: 221.547,
    width: 19.0486,
    height: 23.2733,
    fill: "white"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 434.283,
    y: 250.112,
    width: 19.0486,
    height: 23.2733,
    fill: "white"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 458.095,
    y: 250.112,
    width: 19.0486,
    height: 23.2733,
    fill: "white"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 434.111,
    y: 278.677,
    width: 19.0486,
    height: 13.7761,
    fill: "white"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 457.923,
    y: 278.677,
    width: 19.0486,
    height: 13.7761,
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 285.49,
    cy: 76.0207,
    r: 4.26457,
    stroke: "#11334E",
    strokeWidth: 3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M368.29 291.93V274.636M317.981 75.4963L368.29 32V58.2026M368.29 58.2026L389.776 75.4963M368.29 58.2026V90.4318M389.776 75.4963H412.31M389.776 75.4963H290.73M389.776 75.4963V106.677M389.776 75.4963L368.29 90.4318M368.29 274.636L389.776 289.309V259.962M368.29 274.636L389.776 259.962M368.29 274.636V245.289M389.776 259.962L368.29 245.289M389.776 259.962V230.092M368.29 245.289L389.776 230.092M368.29 245.289V214.37M389.776 230.092L368.29 214.37M389.776 230.092V198.648M368.29 214.37L389.776 198.648M368.29 214.37V183.975M389.776 198.648L368.29 183.975M389.776 198.648V167.729M368.29 183.975L389.776 167.729M368.29 183.975V153.056M389.776 167.729L368.29 153.056M389.776 167.729V137.858M368.29 153.056L389.776 137.858M368.29 153.056V122.661M389.776 137.858L368.29 122.661M389.776 137.858V106.677M368.29 122.661L389.776 106.677M368.29 122.661V90.4318M389.776 106.677L368.29 90.4318M284.966 80.7368V158.296",
    stroke: "#11334E",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 293.863,
    x2: 504,
    y2: 293.863,
    stroke: "#DBE9F4",
    strokeWidth: 8
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M420 105C420 100.582 423.582 97 428 97H482C486.418 97 490 100.582 490 105V292H420V105Z",
    fill: "url(#paint0_linear_13071_804)",
    fillOpacity: 0.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M94.1688 109.065C94.1688 104.647 97.7505 101.065 102.169 101.065H230C234.418 101.065 238 104.647 238 109.065V292.453H94.1688V109.065Z",
    fill: "#DBE9F4"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 150.597,
    y: 112.905,
    width: 29.5803,
    height: 25.0641,
    fill: "white"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 113.616,
    y: 112.905,
    width: 29.5803,
    height: 25.0641,
    fill: "white"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 187.575,
    y: 112.905,
    width: 29.5803,
    height: 25.0641,
    fill: "white"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 150.597,
    y: 143.344,
    width: 29.5803,
    height: 25.0641,
    fill: "white"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 113.616,
    y: 143.344,
    width: 29.5803,
    height: 25.0641,
    fill: "white"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 187.575,
    y: 143.344,
    width: 29.5803,
    height: 25.0641,
    fill: "white"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 150.597,
    y: 173.779,
    width: 29.5803,
    height: 25.0641,
    fill: "white"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 113.616,
    y: 173.779,
    width: 29.5803,
    height: 25.0641,
    fill: "white"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 187.575,
    y: 173.779,
    width: 29.5803,
    height: 25.0641,
    fill: "white"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 150.597,
    y: 204.213,
    width: 29.5803,
    height: 25.0641,
    fill: "white"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 113.616,
    y: 204.213,
    width: 29.5803,
    height: 25.0641,
    fill: "white"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 187.575,
    y: 204.213,
    width: 29.5803,
    height: 25.0641,
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M95.3287 108.562C95.3287 104.144 98.9104 100.562 103.329 100.562H230C234.418 100.562 238 104.144 238 108.562V291.951H95.3287V108.562Z",
    fill: "url(#paint1_linear_13071_804)",
    fillOpacity: 0.5
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0933 74.2676C21.0933 69.8493 24.675 66.2676 29.0933 66.2676H109.218C113.636 66.2676 117.218 69.8493 117.218 74.2676V292.454H21.0933V74.2676Z",
    fill: "#F1F6F9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0933 73.7644C21.0933 69.3461 24.675 65.7644 29.0933 65.7644H109.367C113.786 65.7644 117.367 69.3461 117.367 73.7644V291.951H21.0933V73.7644Z",
    fill: "url(#paint2_linear_13071_804)",
    fillOpacity: 0.5
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 40.1234,
    y: 78.5239,
    width: 26.0677,
    height: 27.0027,
    fill: "white"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 72.7056,
    y: 78.5239,
    width: 26.0677,
    height: 27.0027,
    fill: "white"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 40.1234,
    y: 111.314,
    width: 26.0677,
    height: 27.0027,
    fill: "white"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 72.7056,
    y: 111.314,
    width: 26.0677,
    height: 27.0027,
    fill: "white"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 40.1234,
    y: 144.105,
    width: 26.0677,
    height: 27.0027,
    fill: "white"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 72.7056,
    y: 144.105,
    width: 26.0677,
    height: 27.0027,
    fill: "white"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 40.1234,
    y: 176.892,
    width: 26.0677,
    height: 27.0027,
    fill: "white"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 72.7056,
    y: 176.892,
    width: 26.0677,
    height: 27.0027,
    fill: "white"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 40.1234,
    y: 209.682,
    width: 26.0677,
    height: 27.0027,
    fill: "white"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 72.7056,
    y: 209.682,
    width: 26.0677,
    height: 27.0027,
    fill: "white"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 39.8876,
    y: 242.826,
    width: 26.0677,
    height: 27.0027,
    fill: "white"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 72.4698,
    y: 242.826,
    width: 26.0677,
    height: 27.0027,
    fill: "white"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 39.652,
    y: 275.966,
    width: 26.0677,
    height: 15.9837,
    fill: "white"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 72.2343,
    y: 275.966,
    width: 26.0677,
    height: 15.9837,
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M52.31 263.05L77.83 212.34H96.64L70.57 263.05H52.31ZM52.31 272.73V263.05L58.03 258.1H114.57V272.73H52.31ZM88.94 290V241.93H105.88V290H88.94ZM153.771 291.21C147.538 291.21 141.891 289.523 136.831 286.15C131.771 282.777 127.775 278.083 124.841 272.07C121.981 265.983 120.551 258.98 120.551 251.06C120.551 243.067 121.981 236.1 124.841 230.16C127.701 224.147 131.625 219.49 136.611 216.19C141.598 212.817 147.245 211.13 153.551 211.13C159.931 211.13 165.615 212.817 170.601 216.19C175.588 219.49 179.511 224.147 182.371 230.16C185.305 236.173 186.771 243.177 186.771 251.17C186.771 259.163 185.305 266.167 182.371 272.18C179.511 278.193 175.588 282.887 170.601 286.26C165.688 289.56 160.078 291.21 153.771 291.21ZM153.661 275.92C156.888 275.92 159.675 275.003 162.021 273.17C164.368 271.263 166.165 268.477 167.411 264.81C168.731 261.07 169.391 256.523 169.391 251.17C169.391 245.743 168.731 241.197 167.411 237.53C166.165 233.863 164.368 231.113 162.021 229.28C159.675 227.373 156.851 226.42 153.551 226.42C150.398 226.42 147.611 227.337 145.191 229.17C142.845 231.003 141.048 233.753 139.801 237.42C138.555 241.087 137.931 245.633 137.931 251.06C137.931 256.487 138.555 261.033 139.801 264.7C141.048 268.367 142.845 271.153 145.191 273.06C147.611 274.967 150.435 275.92 153.661 275.92ZM192.603 263.05L218.123 212.34H236.933L210.863 263.05H192.603ZM192.603 272.73V263.05L198.323 258.1H254.863V272.73H192.603ZM229.233 290V241.93H246.173V290H229.233Z",
    fill: "url(#paint3_linear_13071_804)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_13071_804)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13071_804)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 253.534,
    y: 163.621,
    width: 88.5265,
    height: 119.406,
    rx: 5,
    transform: "rotate(-25.9993 253.534 163.621)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.275,
    y: 164.006,
    width: 98,
    height: 13,
    transform: "rotate(-25.9993 251.275 164.006)",
    fill: "#E5E8EB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.085,
    cy: 168.834,
    r: 2.56347,
    transform: "rotate(-25.9993 264.085 168.834)",
    fill: "#9F9F9F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 273.301,
    cy: 164.339,
    r: 2.56347,
    transform: "rotate(-25.9993 273.301 164.339)",
    fill: "#9F9F9F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 282.517,
    cy: 159.844,
    r: 2.56347,
    transform: "rotate(-25.9993 282.517 159.844)",
    fill: "#9F9F9F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268.696,
    y: 184.983,
    width: 62.6047,
    height: 27.6168,
    rx: 2,
    transform: "rotate(-28.0441 268.696 184.983)",
    fill: "#E5E8EB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.134,
    y: 218.761,
    width: 50.0837,
    height: 3.68263,
    rx: 1.84131,
    transform: "rotate(-28.0441 288.134 218.761)",
    fill: "#E5E8EB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.942,
    y: 225.911,
    width: 44.1915,
    height: 3.68263,
    rx: 1.84131,
    transform: "rotate(-28.0441 291.942 225.911)",
    fill: "#E5E8EB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297.699,
    y: 238.641,
    width: 61.1316,
    height: 3.68263,
    rx: 1.84131,
    transform: "rotate(-28.0441 297.699 238.641)",
    fill: "#E5E8EB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301.507,
    y: 245.791,
    width: 61.1316,
    height: 3.68263,
    rx: 1.84131,
    transform: "rotate(-28.0441 301.507 245.791)",
    fill: "#E5E8EB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305.315,
    y: 252.942,
    width: 61.1316,
    height: 3.68263,
    rx: 1.84131,
    transform: "rotate(-28.0441 305.315 252.942)",
    fill: "#E5E8EB"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_13071_804",
    x: 246.534,
    y: 117.815,
    width: 145.911,
    height: 160.129,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13071_804"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_13071_804",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13071_804",
    x1: 455,
    y1: 97,
    x2: 455,
    y2: 292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F6F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5BA5E0",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_13071_804",
    x1: 166.664,
    y1: 100.562,
    x2: 166.664,
    y2: 291.951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#98D1FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1F6F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_13071_804",
    x1: 69.2303,
    y1: 65.7644,
    x2: 69.2303,
    y2: 291.951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F6F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8DB9DC",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_13071_804",
    x1: 184.703,
    y1: 180,
    x2: 184.703,
    y2: 359.869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.365385,
    stopColor: "#11334E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2776B4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13071_804"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 253.534,
    y: 163.621,
    width: 88.5265,
    height: 119.406,
    rx: 5,
    transform: "rotate(-25.9993 253.534 163.621)",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusCode404);
export default __webpack_public_path__ + "static/media/statusCode404.e31fdf63a252ccedea56fc328c15fa1c.svg";
export { ForwardRef as ReactComponent };